var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendUnlimitedText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_1566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6624 4.67505H45.4499L36.4624 9.45005H45.6624V4.67505Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5499 4.67505H18.3374V9.45005H27.5374L18.5499 4.67505Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 25.1751C33.4875 25.1751 34.95 24.7501 36.2125 23.9626L52.5 13.7876C52.5 12.5251 51.4749 11.5126 50.2249 11.5126H13.7875C12.525 11.5126 11.5125 12.5376 11.5125 13.7876L27.7999 23.9626C29.0499 24.7501 30.5125 25.1751 32 25.1751Z",
    fill: "#47ADB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4874 16.0624L37.9249 25.1749H52.4874V16.0624Z",
    fill: "#47ADB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5125 16.0624V25.1749H26.075L11.5125 16.0624Z",
    fill: "#47ADB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2125 51.3C34.95 52.075 33.4875 52.4875 32 52.4875C30.5125 52.4875 29.05 52.075 27.7875 51.3L0.125 34.275V59.325C0.125 61.8375 2.1625 63.875 4.675 63.875H59.3125C61.825 63.875 63.8625 61.8375 63.8625 59.325V34.275L36.2125 51.3Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04994 27.45H60.9624C62.5749 27.45 63.8874 28.7625 63.8874 30.375C63.8874 31.3875 63.3624 32.3375 62.4999 32.8625L36.2124 49.025C33.6249 50.6125 30.3624 50.6125 27.7874 49.025L1.51244 32.85C0.13744 32 -0.28756 30.2 0.54994 28.8375C1.08744 27.975 2.03744 27.45 3.04994 27.45ZM30.9874 8.98749C31.6249 9.31249 32.3874 9.31249 33.0249 8.98749L45.6624 2.39999C45.6624 1.09999 44.6374 0.124994 43.3874 0.124994H20.6124C19.3624 0.112494 18.3499 1.11249 18.3374 2.34999C18.3374 2.36249 18.3374 2.37499 18.3374 2.39999L30.9874 8.98749Z",
    fill: "#002C3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_1566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendUnlimitedText);
export default __webpack_public_path__ + "static/media/SendUnlimitedText.6f9438c2ab83396ed072059cef7c7651.svg";
export { ForwardRef as ReactComponent };